import { render } from "./RepositoryPage.vue?vue&type=template&id=45a466f1&scoped=true&ts=true"
import script from "./RepositoryPage.vue?vue&type=script&lang=ts"
export * from "./RepositoryPage.vue?vue&type=script&lang=ts"

import "./RepositoryPage.vue?vue&type=style&index=0&id=45a466f1&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a466f1"]])

export default __exports__